import { FORM_ERROR, SubmissionErrors } from 'final-form';
import { AxiosError } from '../../../../data-layer/notifications/types';

const API_TO_FORM_FIELD_MAPPING: Record<string, string> = {
    domain: 'domain',
    instagram_url: 'instagramUrl',
    telegram_url: 'telegramUrl',
    vk_url: 'vkUrl',
    youtube_url: 'youtubeUrl',
    other_url: 'otherUrl',
    bloggers_register_url: 'bloggersRegisterUrl',
};

const mapApiFieldToFormField = (apiField: string): string =>
    API_TO_FORM_FIELD_MAPPING[apiField] ?? apiField;

export const parseBusinessRegistrationApiErrors = (
    error: unknown,
    defaultMessage: string,
): { submitErrors: SubmissionErrors; notifications: string[] } => {
    const errors = (error as AxiosError).response?.data?.errors;

    if (!errors?.length) {
        return {
            submitErrors: { [FORM_ERROR]: defaultMessage },
            notifications: [defaultMessage],
        };
    }

    const submitErrors: Record<string, string> = {};
    const notifications: string[] = [];

    errors.forEach(({ field, message }) => {
        if (field) {
            submitErrors[mapApiFieldToFormField(field)] = message;
        } else {
            notifications.push(message);
        }
    });

    if (!Object.keys(submitErrors).length) {
        return {
            submitErrors: { [FORM_ERROR]: defaultMessage },
            notifications: notifications.length ? notifications : [defaultMessage],
        };
    }

    return { submitErrors, notifications };
};
